"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _activities = _interopRequireDefault(require("./reducers/activities"));

var _connectivityStatus = _interopRequireDefault(require("./reducers/connectivityStatus"));

var _dictateInterims = _interopRequireDefault(require("./reducers/dictateInterims"));

var _dictateState = _interopRequireDefault(require("./reducers/dictateState"));

var _language = _interopRequireDefault(require("./reducers/language"));

var _readyState = _interopRequireDefault(require("./reducers/readyState"));

var _referenceGrammarID = _interopRequireDefault(require("./reducers/referenceGrammarID"));

var _sendBoxValue = _interopRequireDefault(require("./reducers/sendBoxValue"));

var _sendTimeout = _interopRequireDefault(require("./reducers/sendTimeout"));

var _sendTypingIndicator = _interopRequireDefault(require("./reducers/sendTypingIndicator"));

var _shouldSpeakIncomingActivity = _interopRequireDefault(require("./reducers/shouldSpeakIncomingActivity"));

var _suggestedActions = _interopRequireDefault(require("./reducers/suggestedActions"));

var _default = (0, _redux.combineReducers)({
  activities: _activities["default"],
  connectivityStatus: _connectivityStatus["default"],
  dictateInterims: _dictateInterims["default"],
  dictateState: _dictateState["default"],
  language: _language["default"],
  readyState: _readyState["default"],
  referenceGrammarID: _referenceGrammarID["default"],
  sendBoxValue: _sendBoxValue["default"],
  sendTimeout: _sendTimeout["default"],
  sendTypingIndicator: _sendTypingIndicator["default"],
  shouldSpeakIncomingActivity: _shouldSpeakIncomingActivity["default"],
  suggestedActions: _suggestedActions["default"],
  // TODO: [P3] Take this deprecation code out when releasing on or after January 13 2020
  sendTyping: _sendTypingIndicator["default"]
});

exports["default"] = _default;